export const AI_TOOLS_TITLE = "Free AI-Powered Job Description Generator and Interview Kit";
export const AI_TOOLS_DETAILS = "Craft detailed job descriptions and interview kits effortlessly using cutting-edge AI technology. Our platform streamlines the process for free, helping you save time and ensure consistency in your hiring process.";
export const EXPLORE_SMOOTH_HIRING = "Explore SmoothHiring's ATS Software";
export const EXPLORE_SMOOTH_HIRING_DETAILS = "Seamlessly navigate the hiring process with precision and reach millions of qualified candidates effortlessly through SmoothHiring's comprehensive hiring suite.";
export const HIRE_BEST_CANDIDATES = "Hire the Best Candidates";
export const HIRE_BEST_CANDIDATES_DETAILS = "How does a list of the best employees for your job sound? Utilize SmoothHiring's patented predictive analytics technology to discover top-tier talent.";



export const CUSTOMER_TESTIMONIAL = {
    testimonial: "SmoothHiring's AI job description generator is a game-changer, saving us hours and ensuring top-notch job descriptions in seconds. It's made crafting compelling roles effortless and efficient!",
    name: 'John Smith (HR Manager)',
    rating: 5
};

